import * as React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function SnakBarAnexos({ open, alertText,setOpen }) {
  const handleClose = () =>{
    setOpen(false)
  }
  const vertical = "top"
  const horizontal = "right"
  return (
    <Stack spacing={2} sx={{ width: "100%", height: '100%', top: 0, display:'inline-block' }}>
      <Snackbar 
        anchorOrigin={{ vertical, horizontal }} open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%", height: '100%'  }}>
          {alertText}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
